import { Routes, Route } from 'react-router-dom';
import LanguageLayout from './components/LanguageLayout';
import HomePage from './pages/HomePage';
import ShareViewPage from './pages/ShareViewPage';
import NotFoundPage from './pages/NotFoundPage';
import AuthConfirmEmailPage from './pages/AuthConfirmEmailPage';
import AuthResetPasswordPage from './pages/AuthResetPasswordPage';
import InvitePage from './pages/InvitePage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import HelpCenterPage from './pages/HelpCenterPage';
import ChildSafetyPage from './pages/ChildSafetyPage';

const appRoutes = (
  <>
    <Route index element={<HomePage />} />
    <Route path="s/:shareId" element={<ShareViewPage />} />
    <Route path="auth/confirm-email" element={<AuthConfirmEmailPage />} />
    <Route path="auth/reset-password" element={<AuthResetPasswordPage />} />
    <Route path="invite/:token" element={<InvitePage />} />
    <Route path="terms" element={<TermsPage />} />
    <Route path="privacy" element={<PrivacyPage />} />
    <Route path="help" element={<HelpCenterPage />} />
    <Route path="child-safety" element={<ChildSafetyPage />} />
  </>
);

function App() {
  return (
    <Routes>
      {/* English (default, no prefix) */}
      <Route path="/" element={<LanguageLayout />}>
        {appRoutes}
      </Route>
      {/* Localized routes */}
      <Route path="/:lang" element={<LanguageLayout />}>
        {appRoutes}
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
